module.exports = {
  1: 4719568,
  30: 5481929,
  31: 3949100,
  40: 181142510,
  41: 0,
  56: 149268,
  97: 1585924,
  137: 4931456,
  8453: 0,
  17000: 28838,
  42161: 55,
  43113: 352,
  43114: 820,
  59140: 75,
  59144: 624,
  80001: 4119576,
  84532: 0,
  421614: 646132,
  11155111: 3236805,
  245022934: 0,
  245022926: 0,
}
